'use client';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface SearchFiltersSectionProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
}

export default function SearchFiltersSection({
  categories,
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchQueryChange,
}: SearchFiltersSectionProps) {
  return (
    <section className="bg-white py-8 sm:py-12 px-4 sm:px-6 border-b border-gray-200">
      <div className="max-w-6xl mx-auto">
        {/* Search Bar */}
        <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 max-w-2xl w-full md:mx-auto">
          <div className="flex-1 min-w-0 relative">
            <MagnifyingGlassIcon className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-400 pointer-events-none" />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => onSearchQueryChange(e?.target?.value ?? '')}
              className="w-full pl-10 sm:pl-12 pr-4 py-3 min-h-[44px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent text-charcoal text-base"
            />
          </div>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap items-center justify-start sm:justify-center gap-2 sm:gap-3">
          {categories?.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`min-h-[44px] px-4 sm:px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 active:scale-[0.98] ${
                selectedCategory === category
                  ? 'bg-gold text-white shadow-md'
                  : 'bg-white text-navy border border-navy hover:bg-navy/5'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
